const RO = {
  partnershipIncorporated: [
    "societate în comandită pe acţiuni (SCA)"
  ],
  partnershipUnincorporated: [
    "societate în comandită simplă (SCS)",
    "societate în nume colectiv (SNC)"
  ]
};
export {
  RO as default
};
